import classNames from 'classnames';
import './index.css';

const pad = n => String(n).padStart(2, '0');

const EditorialSection = ({ index, eyebrow, title, meta, headingId, children, className }) => (
  <header className={classNames('ed-section', className)}>
    <div className="ed-section__rule" aria-hidden />
    <div className="ed-section__head">
      <span className="ed-section__eyebrow">
        <span className="ed-section__num">{pad(index)}</span>
        <span className="ed-section__dash" aria-hidden>—</span>
        {eyebrow}
      </span>
      {meta && <span className="ed-section__meta">{meta}</span>}
    </div>
    {title && <h2 id={headingId} className="ed-section__title">{title}</h2>}
    {children}
  </header>
);

export default EditorialSection;
